import { Card, Typography as typography_antd } from "antd";
import LeaveStyle from "../../Components/LeavesStyle";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ErrorIcon from "@mui/icons-material/Error";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { fetchRoleData } from "../../redux/slice/getRoleData";
import { useDispatch, useSelector } from "react-redux";
import env from "../../config/env";
import "./addemployee.css";
import { fetchLeaveSummaryData } from "../../redux/slice/getLeaveSummary";
import { fetchSubLeaveTypeData } from "../../redux/slice/subLeaveType";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import CryptoJS from "crypto-js";
const { Title, Text } = typography_antd;

const UpdateEmployee = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [roleData, setRoleData] = useState();
  const [open, setOpen] = useState(false);
  const [selectVal, setSelectVal] = useState();
  const [assignleaves, setAssignLeaves] = useState({});
  const [takenLeaves, setTakenLeaves] = useState({});
  const [balanceLeaves, setBalanceLeaves] = useState({});
  const [leaveTypes, setLeaveTypes] = useState({});
  const [preventDoubleClick, setpreventDoubleClick] = useState(false);
  const [updateEmployeeData, setUpdateEmployeeData] = useState({
    name: location.state.name,
    designation: location.state.designation,
    company_email: location.state.company_email,
    role: location.state.role_value,
    salary: location.state.salary,
    joining_date: location.state.joining_date,
    flag: location.state.active_user === true ? "Active" : "Inactive",
  });
  const [errorText, setErrorText] = useState({
    name: "",
    designation: "",
    company_email: "",
    role: "",
    salary: "",
    flag: "",
  });

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  if (state?.getRoleData?.data?.status === 555 || state?.getRoleData?.data?.status === 501
    || state?.getLeaveSummary?.data?.status === 555 || state?.getLeaveSummary?.data?.status === 501
    || state?.getSubLeaveType?.data?.status === 555 || state?.getSubLeaveType?.data?.status === 501
  ) {
    dispatch(setToken(null));
    dispatch(setUserData(null));
    toast.error("Session expire, Please LogIn!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "1",
    });
    Navigate("/login")
  }
  const temp = state?.getRoleData.data?.data;
  let tempLeaveSummury = state?.getLeaveSummary?.data?.data;
  const subLeaveArr = state?.getSubLeaveType?.data?.data;

  useEffect(() => {
    if (location) {
      const obj = {
        id: location?.state?.id,
        token: token,
      }
      dispatch(fetchSubLeaveTypeData(token));
      dispatch(fetchLeaveSummaryData(obj));
    }
  }, [location]);

  useEffect(() => {
    dispatch(fetchRoleData(token));
  }, [token]);

  useEffect(() => {
    setRoleData(temp);
  }, [temp]);

  useEffect(() => {
    if (tempLeaveSummury) {
      start();
    }
  }, [tempLeaveSummury]);

  //   useEffect(() => {
  //     const unblock = history.block((location, action) => {
  //       if (isDataChanged()) {
  //         unblock();
  //         setOpen(true);
  //         return false;
  //       }
  //       return true;
  //     });

  //     return () => {
  //       unblock();
  //     };
  //   }, [history]);

  const isDataChanged = () => {
    // Compare the current data with the original data from the location state
    return (
      updateEmployeeData.name !== location.state.name ||
      updateEmployeeData.designation !== location.state.designation ||
      updateEmployeeData.company_email !== location.state.company_email ||
      updateEmployeeData.role !== location.state.role_value ||
      updateEmployeeData.joining_date !== location.state.joining_date ||
      updateEmployeeData.flag !==
      (location.state.active_user === true ? "Active" : "Inactive")
    );
  };

  const start = async () => {
    let obj = {};
    let obj2 = {};
    let obj3 = {};
    let leave_taken = {};

    tempLeaveSummury?.map((doc) => {
      obj = doc.leave_summary;
      obj2 = doc.remaining_leave_summary;
      Object.keys(obj).map((key) => {
        obj3 = {
          ...obj3,
          [key]: obj[key] - obj2[key],
        };
      });
      obj = Object.fromEntries(
        Object.entries(obj).filter(
          ([key, value]) => key !== "id" && key !== "user_id"
        )
      );
      obj2 = Object.fromEntries(
        Object.entries(obj2).filter(
          ([key, value]) => key !== "id" && key !== "user_id"
        )
      );
      obj3 = Object.fromEntries(
        Object.entries(obj3).filter(
          ([key, value]) => key !== "id" && key !== "user_id"
        )
      );

      setAssignLeaves(obj);
      setBalanceLeaves(obj2);
      setTakenLeaves(obj3);
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (e.target.value !== "") {
      setUpdateEmployeeData({
        ...updateEmployeeData,
        [name]: value,
      });
      setErrorText({
        ...errorText,
        [name]: "",
      });
    } else {
      setUpdateEmployeeData({
        ...updateEmployeeData,
        [name]: "",
      });
    }
  };

  const handleChange = (val) => {
    setSelectVal(val);
    setUpdateEmployeeData({ ...updateEmployeeData, role: val });

    if (val !== "") {
      setErrorText({
        ...errorText,
        role: "",
      });
    } else {
      setErrorText({
        ...errorText,
        role: "Please input your role!",
      });
    }
  };

  const dateFormate = (date) => {
    const time = date.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const d = date.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    return `${d}, ${time}`;
  };

  const onFinish = async () => {
    let errorAny = false;
    let obj = { ...errorText };
    if (updateEmployeeData.name === "") {
      obj.name = "Name is required!";
    }
    if (updateEmployeeData.designation === "") {
      obj.designation = "Please input your designation!";
    }
    if (updateEmployeeData.company_email === "") {
      obj.company_email = "Email is required!";
    }
    if (updateEmployeeData.role === "") {
      obj.role = "Please input your role!";
    }
    if (updateEmployeeData.salary === "") {
      obj.dob = "Employee salary is required!";
    }

    setErrorText({ ...obj });
    if (
      assignleaves?.compensate_leave === "" ||
      assignleaves?.lwp_leave === "" ||
      assignleaves?.maternity_leave === "" ||
      assignleaves?.paid_leave === "" ||
      assignleaves?.flag === "" ||
      assignleaves?.paternity_leave === ""
    ) {
      errorAny = true;
      toast.error("Please Enter  Number In Assign Leave!", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: "1",
      });
    } else {
      try {

        const data = {
          compensate_leave: parseFloat(assignleaves?.compensate_leave),
          lwp_leave: parseFloat(assignleaves?.lwp_leave),
          maternity_leave: parseFloat(assignleaves?.maternity_leave),
          paid_leave: parseFloat(assignleaves?.paid_leave),
          paternity_leave: parseFloat(assignleaves?.paternity_leave),
          userId: location?.state?.id,
        }

        // Encrypt data
        const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

        //Encrypt api endpoint
        const updateLeaveSummary = CryptoJS.SHA256("/updateLeaveSummary" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(`${env.backend_api_endpoint}/${updateLeaveSummary}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptedBody }),
        }
        );
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
          }
        }
        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
        }
      } catch (error) {
        console.error("Error Add Employee in:", error.message);
      }
    }
    if (
      obj.name == "" &&
      obj.designation == "" &&
      obj.company_email == "" &&
      obj.role == "" &&
      obj.salary == "" &&
      !errorAny
    ) {
      setpreventDoubleClick(true);
      let id = "";
      roleData.map((value) => {
        if (value.value === updateEmployeeData?.role) {
          id = value.id;
        }
      });
      const tempvalue = updateEmployeeData?.salary?.toLocaleString();

      let salaryValue = parseFloat(tempvalue.replace(/,/g, ""));
      try {

        const data = {
          userId: location?.state?.id,
          name: updateEmployeeData?.name,
          companyEmail: updateEmployeeData?.company_email,
          designation: updateEmployeeData?.designation,
          role: id !== "" && id,
          salary: salaryValue,
          activeUser: updateEmployeeData?.flag === "Active" ? 1 : 0,
          joiningDate: updateEmployeeData?.joining_date,
          deactivated_date: updateEmployeeData?.flag === "Inactive" ? new Date().toISOString() : null
        }

        // Encrypt data
        const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

        //Encrypt api endpoint
        const updateEmployee = CryptoJS.SHA256("/updateEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(`${env.backend_api_endpoint}/${updateEmployee}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptedBody }),
        }
        );
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            setUpdateEmployeeData({
              name: "",
              designation: "",
              company_email: "",
              role: "",
              salary: "",
              joining_date: "",
            });
            toast.success("Profile Updated successfully!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            navigate("/allemployee");
          }
        }
        if (!response.ok) {
          const errorData = await response.json();

          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
        }
      } catch (error) {
        console.error("Error punching in:", error.message);
      }
    }
  };

  const leaveHandler = () => {
    if (isDataChanged()) {
      setOpen(true);
    } else {
      navigate("/allemployee");
    }
  };

  const handlerback = () => {
    setOpen(false);
    navigate("/allemployee");
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSalary = (value) => {
    // Convert the value to a number using parseFloat
    const tempvalue = value?.toLocaleString();
    const numericValue = parseFloat(tempvalue?.replace(/,/g, ""));
    // Check if the numericValue is a valid number
    if (isNaN(numericValue)) {
      // Handle the case where the value is not a valid number
      return "";
    }
    // Use Intl.NumberFormat to format the number
    return Intl.NumberFormat("en-US").format(numericValue);
  };

  return (
    <LeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{ height: "calc(100vh - 75px)", }}
          bordered={false}
          id="add"
          style={{
            margin: 10,
          }}
        >
          <ArrowBackIcon
            onClick={leaveHandler}
            style={{
              fontSize: "22px",
              position: "absolute",
              top: "37px",
              color: "#244DA0",
            }}
          />
          <div
            style={{ display: "flex", marginTop: "3px", paddingLeft: "50px" }}
          >
            <Title
              level={2}
              style={{
                color: "#244DA0",
                fontFamily: "ImportedMilliardBold",
              }}
            >
              Edit Employee
            </Title>
          </div>
          <div className="add-employee-scrollbox">
            <div className="profileItem">
              <div>
                <Typography className="label_text_profile">
                  Name<span style={{ color: "red" }}>*</span>{" "}
                </Typography>
                <TextField
                  name="name"
                  placeholder="Name"
                  fullWidth
                  size="small"
                  defaultValue={updateEmployeeData.name}
                  onChange={handleFormChange}
                  error={errorText.name}
                  helperText={errorText.name !== "" ? errorText.name : ""}
                />
              </div>
              <div>
                <Typography className="label_text_profile">
                  Email<span style={{ color: "red" }}>*</span>{" "}
                </Typography>
                <TextField
                  name="company_email"
                  placeholder="Enter Company Email"
                  fullWidth
                  size="small"

                  defaultValue={updateEmployeeData.company_email}
                  onChange={handleFormChange}
                  error={errorText.company_email}
                  helperText={errorText.company_email}
                />
              </div>
              <div>
                <Typography className="label_text_profile">
                  Designation<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="designation"
                  placeholder="Enter Designation"
                  fullWidth
                  size="small"
                  defaultValue={updateEmployeeData.designation}
                  onChange={handleFormChange}
                  error={errorText.designation}
                  helperText={errorText.designation}
                />
              </div>
              <div>
                <Typography className="label_text_profile">
                  Joining Date<span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    fullWidth
                    slotProps={{
                      textField: {
                        size: 'small',
                        InputProps: {
                          sx: {
                            '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                              color: '#6B7280',
                              fill: '#6B7280',
                              opacity: 1,
                            },
                          },
                        },
                      },
                    }}
                    disabled
                    name="joining_date"
                    defaultValue={
                      updateEmployeeData?.joining_date
                        ? dayjs(updateEmployeeData?.joining_date)
                        : null
                    }
                    onChange={(e) => {
                      setUpdateEmployeeData({
                        ...updateEmployeeData,
                        joining_date: dateFormate(new Date(e)),
                      });
                    }}
                    style={{ width: "100%" }}
                  />
                </LocalizationProvider>
              </div>
              <div>
                <Typography className="label_text_profile">
                  Role<span style={{ color: "red" }}>*</span>
                </Typography>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  sx={{
                    height: 40,
                    // fontFamily: "Millard !important",
                  }}
                  name="role"
                  placeholder="Select Role"
                  onChange={(e) => handleChange(e.target.value)}
                  fullWidth
                  value={selectVal}
                  defaultValue={updateEmployeeData.role}
                  error={errorText.role}
                  helperText={errorText.role}
                >
                  {roleData &&
                    roleData.map((role) => (
                      <MenuItem key={role?.id} value={role.value}>
                        {role.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {errorText.role}
                </FormHelperText>
              </div>
              <div>
                <Typography className="label_text_profile">
                  Employee Salary<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  placeholder="Enter Salary"
                  fullWidth
                  name="salary"
                  type="text"
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" color="black">
                        ₹
                      </InputAdornment>
                    ),
                  }}
                  defaultValue={
                    updateEmployeeData?.salary &&
                    handleSalary(updateEmployeeData?.salary)
                  }
                  value={
                    updateEmployeeData?.salary &&
                    handleSalary(updateEmployeeData?.salary)
                  }
                  inputProps={{
                    inputMode: "numeric", // Ensures mobile keyboards show numbers
                    pattern: "[0-9]*", // Allows only digits
                    min: 0, // Ensures the value can't be negative
                  }}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleFormChange}
                  error={errorText?.salary}
                  helperText={errorText?.salary}
                />
              </div>
              <div>
                <Typography className="label_text_profile">
                  Status <span style={{ color: "red" }}>*</span>
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="radio-buttons-group"
                  defaultValue={updateEmployeeData?.flag}
                  value={updateEmployeeData?.flag}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontFamily: "Milliard",
                    },
                  }}
                  onChange={(e) => {
                    setErrorText({
                      ...errorText,
                      flag: "",
                    });
                    setUpdateEmployeeData({
                      ...updateEmployeeData,
                      flag: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    key="Active"
                    value="Active"
                    control={<Radio
                      sx={{
                        '&.Mui-checked': {
                          color: "#244DA0",
                        },
                      }}
                    />}
                    label="Active"
                  />
                  <FormControlLabel
                    key="Inactive"
                    value="Inactive"
                    control={<Radio
                      sx={{
                        '&.Mui-checked': {
                          color: "#244DA0",
                        },
                      }}
                    />}
                    label="Inactive"
                  />
                </RadioGroup>
                <FormHelperText style={{ color: "#d32f2f" }}>
                  {errorText.flag}
                </FormHelperText>
              </div>
            </div>
            <div className="add_employee_assign_leave_box">
              <div>
                <Title
                  level={4}
                  style={{
                    color: "#244DA0",
                    fontFamily: "ImportedMilliardBold",
                    marginLeft: "20px",
                  }}
                >
                  Assign Leaves
                </Title>
              </div>
              <Grid container spacing={2} className="Leave_item">
                <Grid item xs={4.5} sm={4} lg={4} md={4} xl={4} xxl={4}>
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "16px",
                    }}
                  ></Typography>
                </Grid>
                <Grid
                  item
                  xs={2.5}
                  sm={2.5}
                  lg={2.5}
                  md={2.5}
                  xl={2.5}
                  xxl={2.5}
                  id="Leave_model"
                >
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "14px",
                    }}
                  >
                    Days Assign
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2.5}
                  sm={2.5}
                  lg={2.5}
                  md={2.5}
                  xl={2.5}
                  xxl={2.5}
                  id="Leave_model"
                >
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "14px",
                    }}
                  >
                    Days Taken{" "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={2.5}
                  sm={2.5}
                  lg={2.5}
                  md={2.5}
                  xl={2.5}
                  xxl={2.5}
                  id="Leave_model"
                >
                  <Typography
                    style={{
                      fontFamily: "ImportedMilliardSemibold",
                      fontSize: "14px",
                    }}
                  >
                    Leave Balance
                  </Typography>
                </Grid>
              </Grid>
              {subLeaveArr?.map((val) => {
                let key = val.sub_leave_type_id;
                return (
                  <Grid container spacing={2} className="Leave_item">
                    <Grid item xs={4.5} sm={4} lg={4} md={4} xl={4} xxl={6}>
                      <Typography
                        style={{
                          fontFamily: "ImportedMilliardSemibold",
                          fontSize: "14px",
                        }}
                      >
                        {val?.sub_leave_title}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2.5}
                      sm={2.5}
                      lg={2.5}
                      md={2.5}
                      xl={2.5}
                      xxl={3}
                      id="Leave_model"
                    >
                      <TextField
                        style={{ borderRadius: "5px", maxWidth: "100px" }}
                        type="number"
                        variant="outlined"
                        inputProps={{
                          inputMode: "numeric", // Ensures mobile keyboards show numbers
                          pattern: "[0-9]*", // Allows only digits
                          min: 0, // Ensures the value can't be negative
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onBlur={(e) => {
                          if (
                            e.target.value != "" &&
                            e.target.value < (takenLeaves[key] ?? 0)
                          ) {
                            toast.error(
                              "Please Enter More Number Then Taken Days Number !",
                              {
                                position: toast.POSITION.TOP_RIGHT,
                                toastId: "1",
                              }
                            );
                            const takenLeavesKey = takenLeaves[key] ?? 0;
                            setAssignLeaves({
                              ...assignleaves,
                              [key]: takenLeavesKey,
                            });
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]: 0,
                            });
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value === "") {
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]: 0,
                            });
                          }
                          if (e.target.value < 0) {
                            toast.error("Please Enter Positive Number !", {
                              position: toast.POSITION.TOP_RIGHT,
                              toastId: "1",
                            });
                            setAssignLeaves({
                              ...assignleaves,
                              [key]: 0,
                            });
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]: 0,
                            });
                          } else {
                            setAssignLeaves({
                              ...assignleaves,
                              [key]:
                                e.target.value == ""
                                  ? ""
                                  : parseInt(e.target.value),
                            });
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]:
                                parseInt(e.target.value) -
                                (takenLeaves[key] ?? 0),
                            });
                          }
                        }}
                        defaultValue={
                          key in assignleaves ? assignleaves[key] : 0
                        }
                        value={key in assignleaves ? assignleaves[key] : 0}
                        min={0}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2.5}
                      sm={2.5}
                      lg={2.5}
                      md={2.5}
                      xl={2.5}
                      xxl={3}
                      id="Leave_model"
                    >
                      <TextField
                        style={{ borderRadius: "5px", maxWidth: "100px" }}
                        type="number"
                        variant="outlined"
                        disabled
                        inputProps={{
                          inputMode: "numeric", // Ensures mobile keyboards show numbers
                          pattern: "[0-9]*", // Allows only digits
                          min: 0, // Ensures the value can't be negative
                        }}
                        onKeyDown={(e) => {
                          if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value === "") {
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]: assignleaves[key] - 0,
                            });
                          }
                          if (e.target.value < 0) {
                            toast.error("Please Enter Positive Number !", {
                              position: toast.POSITION.TOP_RIGHT,
                              toastId: "1",
                            });
                            setTakenLeaves({
                              ...takenLeaves,
                              [key]: 0,
                            });
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]: 0,
                            });
                          } else if (
                            assignleaves[key] > 0
                              ? assignleaves[key] < e.target.value
                              : 0 < e.target.value
                          ) {
                            toast.error(
                              "Please Enter Less Number Then Assign Days Number !",
                              {
                                position: toast.POSITION.TOP_RIGHT,
                                toastId: "1",
                              }
                            );
                            setTakenLeaves({
                              ...takenLeaves,
                              [key]:
                                assignleaves[key] > 0 ? assignleaves[key] : 0,
                            });
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]: 0,
                            });
                          } else {
                            setTakenLeaves({
                              ...takenLeaves,
                              [key]:
                                e.target.value == ""
                                  ? ""
                                  : parseInt(e.target.value),
                            });
                            setBalanceLeaves({
                              ...balanceLeaves,
                              [key]:
                                assignleaves[key] - parseInt(e.target.value),
                            });
                          }
                        }}
                        defaultValue={key in takenLeaves ? takenLeaves[key] : 0}
                        value={key in takenLeaves ? takenLeaves[key] : 0}
                        min={0}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2.5}
                      sm={2.5}
                      lg={2.5}
                      md={2.5}
                      xl={2.5}
                      xxl={2}
                      id="Leave_model"
                    >
                      <TextField
                        style={{ borderRadius: "5px", maxWidth: "100px" }}
                        type="number"
                        variant="outlined"
                        disabled
                        onChange={(e) => {
                          setAssignLeaves({
                            ...assignleaves,
                            [key]:
                              e.target.value == ""
                                ? ""
                                : parseInt(e.target.value),
                          });
                        }}
                        defaultValue={
                          key in balanceLeaves ? balanceLeaves[key] : 0
                        }
                        value={key in balanceLeaves ? balanceLeaves[key] : 0}
                        min={0}
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
              }}
            >
              <Button
                size="large"
                variant="contained"
                id="submit_btn"
                onClick={onFinish}
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  textTransform: "none",
                  height: "fit-content",
                  width: "200px",
                  fontFamily: "MilliardMedium"
                }}
                disabled={preventDoubleClick}
              >
                Update
              </Button>
            </div>
          </div>
        </Card>
      </div>
      <Dialog
        open={open}
        onClose={handleCancel}
        style={{ width: "400px", left: "40%" }}
      >
        <DialogContent>
          <center>
            <ErrorIcon style={{ fontSize: "50px" }} />
          </center>
          <p
            style={{
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "center",
              marginTop: "15px",
              color: "rgba(0, 0, 0, 0.66)",
            }}
          >
            Are you sure you want to discard your changes?
          </p>
        </DialogContent>
        <DialogActions
          style={{ justifyContent: "center", marginBottom: "10px" }}
        >
          <Button
            block
            size="large"
            key="submit"
            type="primary"
            onClick={handlerback}
            style={{
              backgroundColor: "#E20E0E",
              borderRadius: "6px",
              fontWeight: "500",
              borderColor: "#E20E0E",
              color: "white",
              width: "120px",
              textTransform: "none",
            }}
          >
            Discard
          </Button>
          <Button
            size="large"
            block
            key="back"
            onClick={handleCancel}
            style={{
              backgroundColor: "#244DA0",
              borderRadius: "6px",
              color: "white",
              fontWeight: "500",
              borderColor: "#244DA0",
              width: "120px",
              textTransform: "none",
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </LeaveStyle>
  );
};

export default UpdateEmployee;
